import { gql } from '@apollo/client';

export const USER_EVENTS_SUBSCRIPTION = gql`
  subscription OnUserEvents {
    userEvents {
      __typename

      ... on VideoCallStarted {
        sessionName
      }

      ... on VideoCallDisconnected {
        sessionName
      }

      ... on ClientExitedCall {
        sessionName
        clientName
        durationSeconds
        estimatedDuration
      }

      ... on InstantStylingMatchStatus {
        requestId
        stylistUserId
        clientUserId
        stylistAccepted
        clientAccepted
        paymentId
        consultationId
        stylistDeclined
        clientDeclined
        clientCancelled
      }

      ... on InstantStylingTimeout {
        message
      }

      ... on LookbookPurchased {
        sendbirdMessageId
      }
    }
  }
`;
